import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, useTheme } from '@mui/material';
import { Chips } from '../../../components/chips/chips';

interface PlayerCardProps {
  isConneqted: boolean;
}

export function ConneqtStatusCell({ isConneqted }: PlayerCardProps) {
  const { t } = useTranslation();
  const theme = useTheme();

  const playerStatusDarkTextColor = {
    '& .MuiChip-label': {
      color: theme.palette.text.secondary,
    },
  };

  return (
    <Grid display="flex" justifyContent="center">
      {isConneqted ? (
        <Chips
          sx={playerStatusDarkTextColor}
          label={t('CONNEQTED').toUpperCase()}
          variant="filled"
          color="primary"
          size="small"
        />
      ) : (
        <Chips
          label={t('NOT_CONNEQTED').toUpperCase()}
          variant="filled"
          color="warning"
          size="small"
        />
      )}
    </Grid>
  );
}
